import React, {useRef, useState, useEffect} from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import ProgressiveImg from '../components/ProgressiveImg';
import FindAgentBlock from '../components/FindAgentBlock';
import questionsActions from '../store/actions/questions';
import {InView} from 'react-intersection-observer';
import {Link} from "react-router-dom";

export const InfoCenter = (effect, deps) => {
    const questionsStore = useSelector((store) => store.questionsStore);
    const dispatch = useDispatch();
    const [inputFocus, setInputFocus] = React.useState(false);
    const resultsRef = useRef(null);
    const [windowWidth, setWindowWidth] = useState(0);

    let resizeWindow = () => {
        setWindowWidth(window.innerWidth);
    };
    const scrollByAside = (id) => {
        document.getElementById('answer' + id).scrollIntoView({block: 'start', behavior: 'smooth'});
    }

    const questionsList = questionsStore.questionsTopicList.map((elem) => (
        <div className="question" key={elem.id} id={`question${elem.id}`} onClick={() => {
            scrollByAside(elem.id)
        }}>
            <div className="content" dangerouslySetInnerHTML={{__html: elem.question}}/>
        </div>
    ));


    const answersList = questionsStore.questionsTopicList.map((elem) => (
        <div
            className="answer"
            key={elem.id}
            id={`answer${elem.id}`}>
            <InView
                onChange={(inView) => {
                    highlightQuestion(elem.id, inView)
                }}
                onClick={(event) => {
                    toggleOpen(event.target)
                }}
                className="answer__heading">
                <div className="answer__heading--text" dangerouslySetInnerHTML={{__html: elem.question}}/>
            </InView>
            <div className="answer__content">
                <div className="answer__content--inner" dangerouslySetInnerHTML={{__html: elem.answer}}/>
            </div>
        </div>
    ));

    const toggleOpen = (elem) => {
        if (elem.parentNode.classList.contains('open')) {
            elem.parentNode.classList.remove('open')
        } else {
            elem.parentNode.classList.add('open')
        }
    }

    const highlightQuestion = (id, inView) => {
        const item = document.getElementById('question' + id);
        if (inView) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    }

    const setSearchString = (event) => {
        dispatch(questionsActions.setSearchString(event.target.value));
        dispatch(questionsActions.searchMatches(
            event.target.value,
            questionsStore.questionsInfoList,
        ));
    }

    const setTopic = (topic) => {
        if (windowWidth < 1025){
            document.getElementById('tabs-list').scrollIntoView({block: 'start', behavior: 'smooth'});
        }
        dispatch(questionsActions.setTopic(topic));
    }

    const searchSubmit = (evt) => {
        evt.preventDefault();
        dispatch(questionsActions.setSearchRequest(questionsStore.searchString));
        dispatch(questionsActions.setSearchMatches([]));
    }

    const clearSearch = () => {
        dispatch(questionsActions.setSearchRequest(''));
        dispatch(questionsActions.setSearchString(''));
    }

    const resultsList = questionsStore.searchResults.map((elem) => (
        <div className="result" key={elem.id} onClick={() => {
            goTo(elem.id)
        }}>
            <div className="result-title" dangerouslySetInnerHTML={{__html: elem.question}}/>
            <div className="result-content" dangerouslySetInnerHTML={{__html: elem.answer_short}}/>
        </div>
    ));
    useEffect(() => {
        dispatch(questionsActions.setSearchRequest(''));
        dispatch(questionsActions.setSearchString(''));
        dispatch(questionsActions.fetchQuestions('infoCenter', questionsStore.topic));
    }, []);

    useEffect(() => {
        dispatch(questionsActions.changeTopicList(questionsStore.questionsInfoList, questionsStore.topic));
        dispatch(questionsActions.fetchSearchResults(
            questionsStore.searchRequest,
            questionsStore.questionsInfoList
        ));
        if (questionsStore.itemToScroll !== null) {
            let id = questionsStore.itemToScroll.id
            setTimeout(function () {
                let elem = document.getElementById('answer' + id);
                elem.scrollIntoView({block: 'start', behavior: 'smooth'});
                elem.classList.add('open');
                dispatch(questionsActions.setItemToScroll(null));
            }, 100);
        }

    }, [questionsStore.topic, questionsStore.searchRequest, questionsStore.itemToScroll, resultsRef]);

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        document.addEventListener("mousedown", handleClickOutside);
        function handleClickOutside(event) {
            if (resultsRef.current && !resultsRef.current.contains(event.target)) {
                setInputFocus(false);
            }
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("resize", resizeWindow);
        };
    }, [])

    const topics = [
        {
            id: 0,
            isActive: true,
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/pic1.svg`,
            text: 'Policy',
            topic: 'POLICY'
        },
        {
            id: 1,
            isActive: false,
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/pic2.svg`,
            text: 'Billing and Payments',
            topic: 'BILLING'
        },
        {
            id: 2,
            isActive: false,
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/pic3.svg`,
            text: 'Claims',
            topic: 'CLAIMS'
        },
        {
            id: 3,
            isActive: false,
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/pic5.svg`,
            text: 'Identity Theft',
            topic: 'IDENTITY'
        },
    ]

    const topicsList = topics.map((elem) => (
        <div className={`topic-item ${questionsStore.topic === elem.topic ? 'active' : ''}`} key={elem.id}
             onClick={() => {
                 setTopic(elem.topic)
             }}>
            <img src={elem.img}/>
            <span>{elem.text}</span>
        </div>
    ));

    const goTo = (id) => {
        let answer = {};
        let topic;
        questionsStore.questionsInfoList.forEach((item) => {
            if (item.id === id) {
                answer = {...item};
            }
        });
        if (answer.display.topic_billing) {
            topic = 'BILLING'
        } else if (answer.display.topic_claims) {
            topic = 'CLAIMS'
        } else if (answer.display.topic_identity) {
            topic = 'IDENTITY'
        } else if (answer.display.topic_policy) {
            topic = 'POLICY'
        }
        dispatch(questionsActions.setSearchRequest(''));
        dispatch(questionsActions.setSearchResults([]));
        dispatch(questionsActions.setTopic(topic));
        dispatch(questionsActions.setItemToScroll(answer));
        setInputFocus(false);
    }

    return (
        <>
            <div className="info-center-page">
                <div className="header-block">
                    <div className="header-block__bg">
                        <div className="header-block__bg--inner">
                            <ProgressiveImg
                                lowQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/first-block-right.png`}
                                highQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/first-block-right.svg`}
                                className="right-picture"
                            />
                            <ProgressiveImg
                                lowQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/first-block-left.png`}
                                highQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/first-block-left.svg`}
                                className="left-picture"
                            />
                        </div>
                    </div>
                    <div className="header-block__content">
                        <div className="title">
                            Info Center
                        </div>
                        <div className="subtitle">
                            Get to know the lingo and details of insurance
                        </div>
                        <div className={`input-block ${questionsStore.searchRequest.length > 0 ? 'has-results' : ''}`} ref={resultsRef}>
                            <form action="" onSubmit={(evt) => searchSubmit(evt)}>
                                <input type="text"
                                       placeholder='Enter your question'
                                       value={questionsStore.searchString}
                                       onFocus={() => {
                                           setInputFocus(true)
                                       }}
                                       onInput={(event) => {
                                           setSearchString(event)
                                       }}
                                />
                                <button type={"submit"}
                                    className='action-btn button-gradient'
                                >
                                    <span>Search</span>
                                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/icon-search.svg`} alt="loop"/>
                                </button>
                            </form>
                            {questionsStore.searchRequest.length > 0 && (
                                <button className="clear" onClick={() => {
                                    clearSearch()
                                }}>
                                    <img
                                        src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`}
                                        alt="close"/>
                                </button>
                            )}
                            {questionsStore.searchMatches.length > 0 && inputFocus && (
                                <div className="input-block__matches">
                                    {
                                        questionsStore.searchMatches.map(item => {
                                            return (
                                                <div className="match-item" key={item.id} onClick={() => {
                                                    goTo(item.id)
                                                }
                                                }>
                                                    <div className="match-content"
                                                         dangerouslySetInnerHTML={{__html: item.question}}/>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className={`content-block ${questionsStore.isLoadingQuestions ? 'is-loading' : ''}`}>
                    <div className="info-center-spinner"/>
                    {questionsStore.searchRequest.length > 0 && questionsStore.searchResults.length > 0 &&
                    (<div className="container">
                        <div className="search-results">
                            <div className="search-results__title">Showing matches
                                for <strong>”{questionsStore.searchRequest}”</strong></div>
                            <div className="search-results__list">
                                {resultsList}
                            </div>
                        </div>
                    </div>)
                    }
                    {questionsStore.searchRequest.length > 0 && questionsStore.searchResults.length < 1 &&
                    (<div className="container">
                        <div className="search-results no-results">
                            <div className="search-results__title">No results found
                                for <strong>”{questionsStore.searchRequest}”</strong></div>
                        </div>
                    </div>)
                    }
                    {questionsStore.searchRequest.length < 1 &&
                    (<div className="tabs">
                        <div className="container">
                            <div className="tabs-heading">
                                <div className="tabs-heading__track">
                                    {topicsList}
                                </div>
                            </div>
                        </div>
                        <div className="tabs-content">
                            <div className="tabs-aside">
                                <div className="tabs-aside__list">
                                    {questionsList}
                                </div>
                            </div>
                            <div className="tabs-list" id="tabs-list">
                                {answersList}
                            </div>
                        </div>
                    </div>)
                    }
                </div>
                <div className="have-a-question-block">
                    <div className="container">
                        <div className="left-side">
                            <img
                                src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/pic13.svg`}
                                alt=""/>
                        </div>
                        <div className="right-side">
                            <div className="title-biggest">
                                Still have questions?
                            </div>
                            <div className="main-text call-us">
                                <div>
                                    Call us at
                                </div>
                                <a className='phone-btn' href="tel:18007923084">
                                    <img
                                        src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/info-center/pic12.svg`}
                                        alt=""/>
                                    1-800-792-3084
                                </a>
                            </div>
                            <div className="main-text">
                                Or feel free to simply drop us a line, and we’ll get right back to you.
                            </div>
                            <Link to="/contact-us" className="action-btn-link">
                                <button className="action-btn button-gradient">
                                    Contact Form
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <FindAgentBlock/>
            </div>
        </>
    );
}
